// extracted by mini-css-extract-plugin
export default {"button":"RemoveAlertButton_button__F2gvR"};